module.exports = __webpack_public_path__ + "img/threeend.4ddd8bd3.png";